import '@styles/ProductCard/style.css'
import cn from 'classnames'
import kebabCase from 'lodash/kebabCase'
import React from 'react'
import { ProductCardSizes } from '@constants'

export interface IProductCard {
  isActive?: boolean
  size?: ProductCardSizes
  cardCss?: string
}

const ProductCard: React.FC<IProductCard> = (props): JSX.Element => {
  const { isActive = true, children, size = ProductCardSizes.Medium, cardCss } = props

  return (
    <div
      className={cn(
        'product-card',
        {
          'product-card-inactive': !isActive
        },
        size ? `product-card-${kebabCase(size)}` : '',
        cardCss
      )}
    >
      {children}
    </div>
  )
}

export default ProductCard
